var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.319,
    viewBox: "0 0 22 22.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#030104;stroke:none;}.b{fill:none;stroke:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.234,4.71a1.544,1.544,0,0,0,1.548-1.545V1.548a1.548,1.548,0,1,0-3.1,0V3.166A1.544,1.544,0,0,0,21.234,4.71Z",
    transform: "translate(-4.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.184,3.482H19.068v.787a2.356,2.356,0,1,1-4.713,0V3.482H8.067v.787a2.357,2.357,0,1,1-4.714,0V3.482L.208,3.443v19.68h20.43l1.57,0ZM20.636,21.556H1.781V8.983H20.638V21.556Z",
    transform: "translate(0 -0.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.883,4.71A1.545,1.545,0,0,0,8.432,3.165V1.548a1.548,1.548,0,1,0-3.1,0V3.166A1.542,1.542,0,0,0,6.883,4.71Z",
    transform: "translate(-1.198 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.186,
    transform: "translate(8.071 9.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.479,
    height: 2.186,
    transform: "translate(12.075 9.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.186,
    transform: "translate(15.788 9.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.184,
    transform: "translate(8.071 13.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.479,
    height: 2.184,
    transform: "translate(12.075 13.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.184,
    transform: "translate(15.788 13.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.184,
    transform: "translate(8.071 17.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.475,
    height: 2.184,
    transform: "translate(4.138 13.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.475,
    height: 2.184,
    transform: "translate(4.138 17.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.479,
    height: 2.184,
    transform: "translate(12.075 17.198)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.476,
    height: 2.184,
    transform: "translate(15.788 17.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.235,3.389",
    transform: "translate(-0.006 -0.792)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlackIcon);
export default __webpack_public_path__ + "static/media/calendar-black-icon.593aa70c.svg";
export { ForwardRef as ReactComponent };